import { Link } from 'react-router-dom';

function AuthLayout({ children }) {
  return (
    <div className="min-h-screen bg-gradient-to-br from-primary-50 to-accent-50 dark:from-gray-900 dark:to-gray-800 flex flex-col">
      {/* Header */}
      <header className="py-6 px-4">
        <Link to="/" className="flex items-center justify-center gap-3">
          <img src="/logo.png" alt="Recipe Grabber" className="w-12 h-12 rounded-xl" />
          <span className="text-2xl font-bold text-gradient">Recipe Grabber</span>
        </Link>
      </header>

      {/* Main content */}
      <main className="flex-1 flex items-center justify-center px-4 py-8">
        <div className="w-full max-w-md">
          {children}
        </div>
      </main>

      {/* Footer */}
      <footer className="py-6 text-center text-sm text-gray-500 dark:text-gray-400">
        <p>Extract recipes from Instagram, TikTok & YouTube</p>
      </footer>
    </div>
  );
}

export default AuthLayout;
